import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { xor } from 'lodash'

import FormRow from 'modules/core/components/FormRow'
import EmployeeSelectorInput from 'modules/core/components/Inputs/EmployeeSelector'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'
import { useAsyncCanBulk } from 'modules/core/lib/useAsyncCan'

import type ReportsForm from 'modules/employees/lib/forms/Reports'
import employees from 'modules/employees/store/collections/employees'

interface Props {
  form: ReportsForm
}

const ExportEmployeeSelector = ({ form }: Props) => {
  const { authorizations: validAuthorizations } = useAsyncCanBulk('leaves.export', employees.models)

  const availableEmployees = employees.filter((employee) => {
    return validAuthorizations.for(employee)
  })

  const [selectedEmployeeIds, setSelectedEmployeeIds] = React.useState<number[]>([])
  const onSelectEmployee = (employeeId: number | [] | null | undefined) => {
    if (!employeeId) {
      setSelectedEmployeeIds([])
      return
    }
    if (employeeId instanceof Array) {
      setSelectedEmployeeIds(employeeId)
    } else {
      setSelectedEmployeeIds(xor(selectedEmployeeIds, [employeeId]))
    }
  }

  useEffect(() => {
    form.setValues({
      employee_ids: selectedEmployeeIds,
    })
  }, [selectedEmployeeIds.length]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <FormRow>
        <Box className="sidebar_employees_export_employee_data_timeoff_employees_button">
          <EmployeeSelectorInput
            hasSubmitButton
            isMultiSelect
            attachment="middle center"
            field={form.get('employee_ids')}
            label={i18n.t('employees.reports.employees')}
            employees={availableEmployees}
            onSelectEmployee={onSelectEmployee}
            selectedEmployeeIds={selectedEmployeeIds}
            multiFilters
          />
        </Box>
      </FormRow>
    </>
  )
}

export default ExportEmployeeSelector
